<!-- Container-fluid starts-->
<div class="container-fluid" *ngIf="visibleAdd">
<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>User List</h5>
                </div>
                <div class="card-body">
                    <div class="btn-popup pull-right">
                    </div>
                    <div class="custom-datatable">
                        <form class="row m-0">



                            <div class="mb-sm-4 col-3">
                                <label>Username</label>
                                <input type='text' class="filter-ngx form-control" placeholder='username'
                                       [(ngModel)]="filterParams.username" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Mobile Number</label>
                                <input type='text' class="filter-ngx form-control" placeholder='mobile number'
                                       [(ngModel)]="filterParams.mobilenumber" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Status</label>
                                <input type='text' class="filter-ngx form-control" placeholder='status'
                                       [(ngModel)]="filterParams.status" (input)="applySearch()"
                                       autocomplete="off"/>
                            </div>


                            <div class="mb-sm-4 col-3">
                                <label>Blocked Message</label>
                                <select class="form-select form-control"
                                        [(ngModel)]="filterParams.blocked_message" (change)="onSelectOwned($event)">
                                    <option value="" [disabled]="true">Select</option>
                                    <option [ngValue]="1">Yes</option>
                                    <option [ngValue]="0">No</option>
                                </select>
                            </div>

                            <div class="mb-sm-4 col-3">
                                <label>Blocked_Add_Channel</label>
                                <select class="form-select form-control"
                                        [(ngModel)]="filterParams.blocked_add_channel" (change)="onSelectOwned($event)">
                                    <option value="" [disabled]="true">Select</option>
                                    <option [ngValue]="1">Yes</option>
                                    <option [ngValue]="0">No</option>
                                </select>
                            </div>
                           <div class="mb-sm-4 col-3 pt-1">
                               <table>
                                   <tr>
                                       <button class="btn btn-primary me-1 mb-3 mt-3" (click)="clearFilter()">Clear</button>
                                       <a class="btn btn-primary me-1 mb-3 mt-3" (click)="AddUser()">Add</a>
                                   </tr>
                               </table>
                            </div>

                        </form>

                    <div class="clearfix"></div>
                    <table class="table table-striped">
                        <thead>
                        <tr>
                            <th></th>
                            <th scope="col" sortable="id" (sort)="onSort($event)">Id</th>
                            <th scope="col" sortable="username" (sort)="onSort($event)">Username</th>
                            <th scope="col" sortable="mobile_number" (sort)="onSort($event)">Mobile Number</th>

                            <th scope="col" sortable="status" (sort)="onSort($event)">Status</th>
                            <th scope="col" sortable="blocked_message" (sort)="onSort($event)">Blocked Message</th>
                            <th scope="col" sortable="blocked_add_channel" (sort)="onSort($event)">Blocked Add Channel</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of data| paginate: { itemsPerPage: 10, currentPage: currentPage, totalItems: total }">
                            <th><input type="checkbox" name="title_select" onclick="onSelect(item.id)"></th>
                            <th scope="row">{{ item.id }}</th>
                            <th scope="row">{{ item.username }}</th>
                            <th scope="row">{{ item.mobilenumber }}</th>
                            <th scope="row">{{ item.status }}</th>
                            <th scope="row">{{ item.blocked_message }}</th>
                            <th scope="row">{{ item.blocked_add_channel }}</th>
                            <th scope="row">{{ item.name }}</th>


                            <th scope="row"><a class="btn btn-primary" (click)="editUser(item.id)">Edit</a>
                            </th>
                            <!-- <th scope="row"><a class="btn btn-primary" [routerLink]="['/pages/create-page/',item.channel_id]">Edit</a></th> -->
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="d-flex justify-content-center p-2">
                        <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</div>

<app-user-edit *ngIf="!visible" [id]="editID" (visibleParentPage)="childEmitted($event)"></app-user-edit>

<app-user-add *ngIf="!visibleAdd"  (visibleParentPageUser)="childEmitted($event)"></app-user-add>


<!-- Container-fluid Ends-->
